module.exports = __webpack_public_path__ + "img/almenu_gomb_palyazatok_lezart.536a449f.png";